<script setup>
import { onBeforeMount, onBeforeUnmount, ref, reactive } from 'vue'
import { useAuthStore } from '../stores/auth.store'
import { useRoute } from 'vue-router'
import axios from 'axios'
import router from '@/router'

const uploadState = reactive({}) // guid -> { uploading, progress, error, placeholders: [] }

let doc_loaded = ref(false)
let doc_guid = useRoute().params.doc_guid
let l_doc_guid = ref()

let messageText = ref('')

let currentParamGuid = ''
let currentParamName = ''

let phoneOrientation = 'Portrait'
let photoOrientation = 'Portrait'

let apachePassword = '560285' //12345678

let vhost = 'https://vngx01.ivn1.ru/defectapp'
//let vhost = 'https://aa6.bazis-motors.ru/defectapp'
let vhostProtocol = window.location.protocol
let vhostReal = window.location.host

let dataUrl = `https://vngx01.ivn1.ru/aa/hs/defect-detection-service/doc/${doc_guid}/`
//let dataUrl = `https://aa6.bazis-motors.ru/aa/hs/defect-detection-service/doc/${doc_guid}/`

let cameraStream = null

const imagesPath = 'pics'
const thumbsPath = 'pics/thumbs'

const $auth = useAuthStore()

const ПустоеЗначениеДаты = -62135596800

//console.log($auth.token)

const axiosConfig = {
  headers: {
    Authorization2: `Bearer ${$auth.token}`
  },
  auth: {
    username: 'НеженецИИ', // apache
    password: apachePassword
  }
}

let res = ref({})
let groups = ref([])
let doc = ref({ defects: {}, photos: [], comments: {}, prices: {}, saved: true })
let photos = ref([])
//let files = ref([])
let tab = ref(null)

let defectParameters = ref({})

// Methods

function st(guid) {
  if (!uploadState[guid]) {
    uploadState[guid] = {
      uploading: false,
      processing: false,
      progress: 0,
      error: null,
      placeholders: []
    }
  }
  return uploadState[guid]
}

const defectsCount = function (group) {
  let count = 0
  let object = doc.value.defects[group]
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const element = object[key]
      if (typeof element === 'object' && Array.isArray(element)) {
        count += element.length > 0 ? 1 : 0 //element.length
      } else {
        count += element === true
      }
    }
  }

  return count
}

const hasDefects = function (item) {
  return (
    (typeof doc.value.defects[item.Группа][item.Параметр.Значение_guid] === 'boolean' &&
      doc.value.defects[item.Группа][item.Параметр.Значение_guid] === true) ||
    (typeof doc.value.defects[item.Группа][item.Параметр.Значение_guid] === 'object' &&
      doc.value.defects[item.Группа][item.Параметр.Значение_guid].length > 0)
  )
}

const needComments = function (Параметр) {
  let needComments = false
  res.value.template.forEach((element) => {
    if (element.Параметр.Значение_guid === Параметр.Значение_guid) {
      if (element.Комментарий) {
        needComments = true
      }
    }
  })
  return needComments
}

const mustComment = function (Параметр) {
  let mustComment = false
  res.value.template.forEach((element) => {
    if (element.Параметр.Значение_guid === Параметр.Значение_guid) {
      if (element.МинимальноеКоличествоСимволовКомментария > 0) {
        mustComment = true
      }
    }
  })
  return mustComment
}

const needPrice = function (Параметр) {
  let needPrice = false
  res.value.template.forEach((element) => {
    if (element.Параметр.Значение_guid === Параметр.Значение_guid) {
      if (element.Стоимость) {
        needPrice = true
      }
    }
  })
  return needPrice
}

const pathToImage = function (path) {
  const rightPath = path.replaceAll('\\', '/')
  const pathToImage = `${vhost}/${imagesPath}/${rightPath}`
  return pathToImage
}

const pathToImageThumbnail = function (path) {
  const rightPath = path.replaceAll('\\', '/')

  // Проверяем, является ли файл видео
  const videoExtensions = ['.mp4', '.avi', '.mov', '.mkv', '.webm'] // Список расширений видео
  const isVideo = videoExtensions.some((ext) => rightPath.toLowerCase().endsWith(ext))
  const isLoading = rightPath.toLowerCase() === 'image-icon-loading'
  const isError = rightPath.toLowerCase() === 'image-icon-error'

  if (isLoading) {
    return `//${vhostReal}/${thumbsPath}/image-icon-loading.gif`
  } else if (isError) {
    return `//${vhostReal}/${thumbsPath}/image-icon-error.png`
  } else if (isVideo) {
    return `//${vhostReal}/${thumbsPath}/video-icon.png`
  } else {
    return `//${vhostReal}/${thumbsPath}/image-icon.png`
  }

  // Если это не видео, возвращаем путь к миниатюре изображения
  //return `${vhost}/${thumbsPath}/${rightPath}`
}

async function addImageToQueue(file, paramGuid, paramName, fileExtension) {
  photos.value.push({
    file: file,
    paramGuid: paramGuid,
    paramName: paramName,
    fileExtension: fileExtension
  })
}

function getDataURL(paramName, paramGuid, file, fileExtension) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = (e) => {
      const fileName =
        paramName.replaceAll(':', '').replaceAll('/', ' ') + ' ' + generateUUID() + '.' + fileExtension
      //const fileName = paramName.replaceAll(':', '') + ' ' + crypto.randomUUID() + '.' + fileExtension
      const dirName =
        new Date(res.value.doc.Реквизиты.Дата.Значение * 1000).getFullYear() +
        '-' +
        res.value.doc.Реквизиты.Номер.Значение
      console.log({
        fileName: fileName,
        fileExtension: fileExtension,
        dirName: dirName,
        guid: paramGuid
      })
      resolve({
        fileName: fileName,
        fileExtension: fileExtension,
        dirName: dirName,
        guid: paramGuid,
        fileData: e.target.result
      })
    }
    reader.onerror = (e) => reject(e.target.result)
    reader.readAsDataURL(file)
  })
}

async function uploadImagesFromQueue() {
  // берём снимок очереди и сразу очищаем, чтобы не словить гонки
  const batch = photos.value.slice()
  if (batch.length === 0) return
  photos.value = []

  // группируем по guid, чтобы стейт был “на параметр”
  const byGuid = {}
  batch.forEach((x) => {
    if (!byGuid[x.paramGuid]) byGuid[x.paramGuid] = []
    byGuid[x.paramGuid].push(x)
  })

  // добавим плейсхолдеры в UI и запомним их индексы по guid
  Object.keys(byGuid).forEach((guid) => {
    const state = st(guid)
    if (state.uploading) {
      // если уже грузится — вернём обратно в очередь (или просто пропустим)
      photos.value.push(...byGuid[guid])
      return
    }

    state.uploading = true
    state.processing = false
    state.progress = 0
    state.error = null
    state.placeholders = []

    byGuid[guid].forEach((currVal) => {
      const idx = res.value.doc.ТабличныеЧасти.МедиаФайлы.length
      state.placeholders.push(idx)

      res.value.doc.ТабличныеЧасти.МедиаФайлы.push({
        НомерСтроки: idx,
        Параметр: { Значение_guid: guid },
        МедиаФайл: { ПутьКФайлу: 'image-icon-loading' }
      })
    })
  })

  try {
    // делаем base64 (как у тебя)
    const results = await Promise.all(
      batch.map((x) => getDataURL(x.paramName, x.paramGuid, x.file, x.fileExtension))
    )

    await axios.put(
      dataUrl,
      { photos: results },
      {
        ...axiosConfig,
        timeout: 600000,
        onUploadProgress: (e) => {
          if (!e.total) return
          const p = Math.round((e.loaded * 100) / e.total)
          // обновляем прогресс всем guid, кто участвует в этом батче
          Object.keys(byGuid).forEach((guid) => {
            const state = st(guid)
            state.progress = p
            if (p >= 100) {
              state.processing = true
            }
          })
        }
      }
    )

    // успех → перечитать документ и убрать локальные следы загрузки
    await fetchCarInspectParams()
    Object.keys(byGuid).forEach((guid) => {
      const state = st(guid)
      state.processing = false
      state.progress = 100
      state.error = null
      state.placeholders = []
    })
  } catch (err) {
    console.error('UPLOAD FAILED', err)

    const guids = Object.keys(byGuid)
    const isTimeout =
      err?.code === 'ECONNABORTED' ||
      err?.code === 'ETIMEDOUT' ||
      err?.message?.toLowerCase().includes('timeout')
    const uploadReached100 = guids.every((guid) => st(guid).progress >= 100)

    if (isTimeout && uploadReached100) {
      guids.forEach((guid) => {
        const state = st(guid)
        state.processing = true
        state.progress = 100
        state.error = null
        state.placeholders = []
      })

      messageText.value =
        '<div style="color:#d97706">Передача медиафайлов завершена, сервер продолжает обработку. Не загружайте файлы повторно — обновите документ через некоторое время.</div>'
      return
    }

    const status = err?.response?.status
    const msg =
      status ? `HTTP ${status}` : (err?.message || 'Ошибка загрузки')

    // помечаем ошибку и убираем плейсхолдеры
    Object.keys(byGuid).forEach((guid) => {
      const state = st(guid)
      state.processing = false
      state.error = msg

      // Вариант A (рекомендую): пометить как error-иконку
      state.placeholders.forEach((idx) => {
        const row = res.value.doc.ТабличныеЧасти.МедиаФайлы[idx]
        if (row && row.МедиаФайл?.ПутьКФайлу === 'image-icon-loading') {
          row.МедиаФайл.ПутьКФайлу = 'image-icon-error'
        }
      })

      // Вариант B: удалить строки (если не хочешь error-иконку)
      // state.placeholders.slice().sort((a,b)=>b-a).forEach((idx) => {
      //   res.value.doc.ТабличныеЧасти.МедиаФайлы.splice(idx, 1)
      // })

      state.placeholders = []
    })

    messageText.value = `<div style="color:red">Ошибка загрузки: ${msg}</div>`
  } finally {
    Object.keys(byGuid).forEach((guid) => {
      st(guid).uploading = false
    })
  }
}

async function saveDocumentLocal() {
  if (l_doc_guid.value == null) {
    l_doc_guid.value = doc_guid
  }
  localStorage.setItem('doc_guid', l_doc_guid.value)
  localStorage.setItem('res', JSON.stringify(res.value))
  localStorage.setItem('groups', JSON.stringify(groups.value))
  localStorage.setItem('doc', JSON.stringify(doc.value))
  localStorage.setItem('photos', JSON.stringify(photos.value))
  localStorage.setItem('tab', JSON.stringify(tab.value))
  localStorage.setItem('defectParameters', JSON.stringify(defectParameters.value))
}

async function loadDocumentFromLocal() {
  l_doc_guid.value = localStorage.getItem('doc_guid')
  const l_res = localStorage.getItem('res')
  const l_groups = localStorage.getItem('groups')
  const l_doc = localStorage.getItem('doc')
  const l_photos = localStorage.getItem('photos')
  const l_tab = localStorage.getItem('tab')
  const l_defectParameters = localStorage.getItem('defectParameters')
  if (l_doc_guid.value !== null && l_doc_guid.value === doc_guid) {
    if (l_res !== null) {
      res.value = JSON.parse(l_res)
    }
    if (l_groups !== null) {
      groups.value = JSON.parse(l_groups)
    }
    if (l_doc !== null) {
      doc.value = JSON.parse(l_doc)
    }
    if (l_photos !== null) {
      photos.value = JSON.parse(l_photos)
    }
    if (l_tab !== null) {
      tab.value = JSON.parse(l_tab)
    }
    if (l_defectParameters !== null) {
      defectParameters.value = JSON.parse(l_defectParameters)
    }
  } else {
    clearDocumentFromLocal()
  }
}

async function clearDocumentFromLocal() {
  l_doc_guid.value = null
  localStorage.removeItem('doc_guid')
  localStorage.removeItem('res')
  localStorage.removeItem('groups')
  localStorage.removeItem('doc')
  localStorage.removeItem('photos')
  localStorage.removeItem('tab')
  localStorage.removeItem('defectParameters')
}

async function saveDocument(command = '') {
  messageText.value = ''
  let object = doc.value.defects
  let commentMessages = []
  //let priceMessages = []
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const defects = object[key]
      for (const defectGuid in defects) {
        if (Object.prototype.hasOwnProperty.call(defects, defectGuid)) {
          const defect = defects[defectGuid]
          if (defect === true) {
            if (!Object.prototype.hasOwnProperty.call(doc.value.comments, defectGuid)) {
              commentMessages.push(defectParameters.value[defectGuid])
            }
            // if (
            //   !Object.prototype.hasOwnProperty.call(doc.value.prices, defectGuid) ||
            //   doc.value.prices[defectGuid] === '' ||
            //   doc.value.prices[defectGuid] === 0
            // ) {
            //   priceMessages.push(defectParameters.value[defectGuid])
            // }
          }
        }
      }
    }
  }

  if (commentMessages.length > 0) {
    messageText.value += '<div>Заполни комментарии: ' + commentMessages.join(', ') + '</div>'
  }

  // if (priceMessages.length > 0) {
  //   messageText.value += '<div>Заполни цены: ' + priceMessages.join(', ') + '</div>'
  // }

  // if (commentMessages.length > 0) {
  //   return
  // }

  if (command !== '') {
    doc.value.command = command
  }

  axios.put(dataUrl, doc.value, axiosConfig).then(function (response) {
    clearDocumentFromLocal()
    fetchCarInspectParams()
    messageText.value = 'Сохранен документ'
  })
}

function startInspection() {
  // messageText.value = ''
  // let object = doc.value.defects
  // let commentMessages = []
  // let priceMessages = []
  // for (const key in object) {
  //   if (Object.prototype.hasOwnProperty.call(object, key)) {
  //     const defects = object[key]
  //     for (const defectGuid in defects) {
  //       if (Object.prototype.hasOwnProperty.call(defects, defectGuid)) {
  //         const defect = defects[defectGuid]
  //         if (defect === true) {
  //           if (!Object.prototype.hasOwnProperty.call(doc.value.comments, defectGuid)) {
  //             commentMessages.push(defectParameters.value[defectGuid])
  //           }
  //           if (
  //             !Object.prototype.hasOwnProperty.call(doc.value.prices, defectGuid) ||
  //             doc.value.prices[defectGuid] === '' ||
  //             doc.value.prices[defectGuid] === 0
  //           ) {
  //             priceMessages.push(defectParameters.value[defectGuid])
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  // if (commentMessages.length > 0) {
  //   messageText.value += '<div>Заполни комментарии: ' + commentMessages.join(', ') + '</div>'
  // }
  // if (priceMessages.length > 0) {
  //   messageText.value += '<div>Заполни цены: ' + priceMessages.join(', ') + '</div>'
  // }
  // if (commentMessages.length > 0 || priceMessages.length > 0) {
  //   return
  // }
  // doc.value.command = 'start'
  // axios.put(dataUrl, doc.value, axiosConfig).then(function (response) {
  //   clearDocumentFromLocal()
  //   fetchCarInspectParams()
  // })
}

function stopInspection() {
  // axios.post(dataUrl, { command: 'stop' }, axiosConfig)
}

let СокращенныйНомер = function (Номер) {
  // `this` указывает на экземпляр vm
  let СокращенныйНомер = Номер
  while (СокращенныйНомер.substring(0, 1) === '0') {
    СокращенныйНомер = СокращенныйНомер.substring(1)
  }
  //СокращенныйНомер.replace(/^[0]+/gi, '');
  return СокращенныйНомер
}

async function fetchCarInspectParams() {
  //console.clear()
  //doc_loaded.value = false
  try {
    console.log(axiosConfig)

    axios
      .get(dataUrl, axiosConfig)
      .then(function (response) {
        console.log('Response:')
        console.log(response)

        // Получаем данные
        res.value = response.data
        //console.log(res.value)

        res.value.template.forEach((element) => {
          defectParameters.value[element['Параметр'].Значение_guid] = element['Параметр'].Имя
        })

        // Сначала строим структуру документа из шаблона и заполняем пустыми значениями
        response.data.template.forEach((element) => {
          // Заполняем массив групп
          if (groups.value.indexOf(element.Группа) === -1) {
            groups.value.push(element.Группа)
            doc.value['defects'][element.Группа] = {}
          }
          // Табличные части
          doc.value.photos[element.Параметр.Значение_guid] = []
          if (element.Параметр.Тип === 'Справочник') {
            doc.value['defects'][element.Группа][element.Параметр.Значение_guid] = []
          } else if (element.Параметр.Тип === 'Строка') {
            doc.value['defects'][element.Группа][element.Параметр.Значение_guid] = ''
          } else if (element.Параметр.Тип === 'Число') {
            doc.value['defects'][element.Группа][element.Параметр.Значение_guid] = 0
          } else {
            doc.value['defects'][element.Группа][element.Параметр.Значение_guid] = false
          }
        })

        // Заполняем реальными значениями из документа
        let ОбнаруженныеНеисправности = res.value.doc.ТабличныеЧасти.ОбнаруженныеНеисправности
        for (const groupName in doc.value['defects']) {
          if (Object.hasOwnProperty.call(doc.value['defects'], groupName)) {
            for (const parameter_guid in doc.value['defects'][groupName]) {
              if (Object.hasOwnProperty.call(doc.value['defects'][groupName], parameter_guid)) {
                ОбнаруженныеНеисправности
                  .filter(function (value) {
                    return value.Параметр.Значение_guid === parameter_guid
                  })
                  .forEach((documentRow) => {
                    if (
                      typeof doc.value['defects'][groupName][parameter_guid] === 'object' &&
                      Array.isArray(doc.value['defects'][groupName][parameter_guid])
                    ) {
                      doc.value['defects'][groupName][parameter_guid].push({
                        id: documentRow.Значение.Значение_guid,
                        title: documentRow.Значение.Значение
                      })
                    } else if (
                      typeof doc.value['defects'][groupName][parameter_guid] === 'boolean'
                    ) {
                      doc.value['defects'][groupName][parameter_guid] =
                        documentRow.Значение.Значение
                    } else {
                      doc.value['defects'][groupName][parameter_guid] =
                        documentRow.Значение.Значение
                    }
                  })
              }
            }
          }
        }

        doc.value.comments = {}
        res.value.doc.ТабличныеЧасти.Комментарии.forEach((element) => {
          doc.value.comments[element.Параметр.Значение_guid] = element.Комментарий.Значение
        })

        doc.value.prices = {}
        res.value.doc.ТабличныеЧасти.Стоимость.forEach((element) => {
          doc.value.prices[element.Параметр.Значение_guid] = element.Стоимость.Значение
        })

        // Флаг, что документ загружен
        loadDocumentFromLocal()
        doc_loaded.value = true

        console.log('doc')
        console.log(doc)
      })
      .catch(function (error) {
        console.log('catch')
        console.log(error)
        if (error.response.status === 401) {
          router.push('/auth')
        }
      })
  } catch (e) {
    console.log(' axios Error')
  }
}

// Handlers
onBeforeMount(async () => {
  if (doc_loaded.value === false) {
    fetchCarInspectParams()
  }
})

onBeforeUnmount(() => {
  stopCamera()
})

document.addEventListener('DOMContentLoaded', function () {
  // The width and height of the captured photo. We will set the
  // width to the value defined here, but the height will be
  // calculated based on the aspect ratio of the input stream.

  var width = 1440 // We will scale the photo width to this
  var height = 0 // This will be computed based on the input stream

  // |streaming| indicates whether or not we're currently streaming
  // video from the camera. Obviously, we start at false.

  var streaming = false

  // The various HTML elements we need to configure or control. These
  // will be set by the startup() function.

  var video = null
  var canvas = null
  var photo = null
  var camera = null
  var output = null
  var startbutton = null

  async function startup() {
    video = document.getElementById('video')
    canvas = document.getElementById('canvas')
    photo = document.getElementById('photo')
    camera = document.getElementById('camera')
    output = document.getElementById('output')
    startbutton = document.getElementById('startbutton')

    output.style.display = 'none'

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1920 },
          height: { ideal: 1440 }
        },
        audio: false
      })
      .then(function (stream) {
        video.srcObject = stream
        video.play()
      })
      .catch(function (err) {
        console.log('An error occurred: ' + err)
      })

    video.addEventListener(
      'canplay',
      function (ev) {
        if (!streaming) {
          height = video.videoHeight / (video.videoWidth / width)

          // Firefox currently has a bug where the height can't be read from
          // the video, so we will make assumptions if this happens.
          if (isNaN(height)) {
            height = width / (4 / 3)
          }

          video.setAttribute('width', width)
          video.setAttribute('height', height)
          canvas.setAttribute('width', width)
          canvas.setAttribute('height', height)
          streaming = true
        }
      },
      false
    )

    clearphoto()
  }

  // Fill the photo with an indication that none has been
  // captured.

  // delete ? double?
  function clearphoto() {
    var context = canvas.getContext('2d')
    context.fillStyle = '#AAA'
    context.fillRect(0, 0, canvas.width, canvas.height)

    var data = canvas.toDataURL('image/png')
    photo.setAttribute('src', data)
  }

  // Capture a photo by fetching the current contents of the video
  // and drawing it into a canvas, then converting that to a PNG
  // format data URL. By drawing it on an offscreen canvas and then
  // drawing that to the screen, we can change its size and/or apply
  // other changes before drawing it.

  // Set up our event listener to run the startup process once loading is complete.
  // window.addEventListener('load', startup, false)

  if (window.DeviceOrientationEvent) {
    window.addEventListener('deviceorientation', (event) => {
      const beta = event.beta // Наклон вверх/вниз
      const gamma = event.gamma // Наклон влево/вправо

      if (Math.abs(beta) > Math.abs(gamma)) {
        phoneOrientation = 'Portrait'
      } else {
        phoneOrientation = 'Landscape'
      }
    })
  } else {
    console.log('DeviceOrientationEvent is not supported.')
  }
})

// Отключение камеры
function stopCamera() {
  const video = document.getElementById('video')

  if (cameraStream) {
    cameraStream.getTracks().forEach((t) => t.stop())
    cameraStream = null
  }

  if (video) {
    video.pause?.()
    video.srcObject = null
  }  
  // old
  // let video = document.getElementById('video')

  // const stream = video.srcObject // Получаем поток из видеоэлемента
  // if (stream) {
  //   const tracks = stream.getTracks() // Получаем все треки из потока
  //   tracks.forEach((track) => track.stop()) // Останавливаем каждый трек
  //   video.srcObject = null // Очищаем привязку потока
  // }
}

async function openCamera(guid, name) {

  currentParamGuid = guid
  currentParamName = name
  document.getElementById('modalCamera').style.display = 'flex'

  // запуск камеры только тут
  await startCamera()
}

async function startCamera() {
  
  const video = document.getElementById('video')
  const canvas = document.getElementById('canvas')
  const output = document.getElementById('output')

  output.style.display = 'none'

  if (!video) return

  // если уже есть поток — не стартуем заново
  if (cameraStream) return

  try {
    cameraStream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: 'environment' },
        width: { ideal: 1920 },
        height: { ideal: 1440 }
      },
      audio: false
    })

    video.srcObject = cameraStream
    await video.play()

    // var width = 1440 // We will scale the photo width to this
    // var height = 0 // This will be computed based on the input stream

    // video.setAttribute('width', width)
    // video.setAttribute('height', height)
    // canvas.setAttribute('width', width)
    // canvas.setAttribute('height', height)

  } catch (err) {
    console.error('getUserMedia error:', err)
    messageText.value = '<div style="color:red">Не удалось открыть камеру. Проверь разрешения.</div>'
    cameraStream = null
  }
}

function closeCamera() {
  currentParamGuid = ''
  document.getElementById('modalCamera').style.display = 'none'

  // остановка камеры тут
  stopCamera()

  // на всякий случай прячем превью
  document.getElementById('output').style.display = 'none'
}

function takepicture() {
  saveDocument()

  photoOrientation = phoneOrientation

  let video = document.getElementById('video')
  let canvas = document.getElementById('canvas')
  let canvas2 = document.getElementById('canvas2')
  let photo = document.getElementById('photo')
  let photo2 = document.getElementById('photo2')
  let output = document.getElementById('output')

  // let width = canvas.getAttribute('width')
  // let height = canvas.getAttribute('height')

  // ✅ БЕРЁМ ИЗ VIDEO
  const width = video.videoWidth
  const height = video.videoHeight

  // let width = 1080
  // let height = 1920

  var context = canvas.getContext('2d')
  if (width && height) {
    canvas.width = width
    canvas.height = height
    context.drawImage(video, 0, 0, width, height)
    var data = canvas.toDataURL('image/jpeg')
    photo.setAttribute('src', data)

    canvas2.width = height // Меняем местами ширину и высоту для поворота
    canvas2.height = width
    var context2 = canvas2.getContext('2d')
    context2.translate(canvas2.width / 2, canvas2.height / 2)
    context2.rotate((-90 * Math.PI) / 180) // Поворот на -90 градусов (влево)
    context2.drawImage(video, -width / 2, -height / 2)
    var data2 = canvas2.toDataURL('image/jpeg')
    photo2.setAttribute('src', data2)

    output.style.display = 'flex'
  } else {
    clearphoto()
  }
}

function clearphoto() {
  let canvas = document.getElementById('canvas')
  let context = canvas.getContext('2d')
  let photo = document.getElementById('photo')
  context.fillStyle = '#AAA'
  context.fillRect(0, 0, canvas.width, canvas.height)

  var data = canvas.toDataURL('image/png')
  photo.setAttribute('src', data)
}

function rejectPhoto() {
  document.getElementById('output').style.display = 'none'
}

function savePhoto() {
  let photoImgId = photoOrientation === 'Landscape' ? 'photo2' : 'photo'

  const photo = document.getElementById(photoImgId)
  const src = photo.getAttribute('src')

  const fileName = currentParamName.replaceAll(':', '').replaceAll('/', ' ') + ' ' + generateUUID() + '.jpg'
  //alert(fileName)
  //const fileName = currentParamName.replaceAll(':', '') + ' ' + crypto.randomUUID() + '.jpg'
  const dirName =
    new Date(res.value.doc.Реквизиты.Дата.Значение * 1000).getFullYear() +
    '-' +
    res.value.doc.Реквизиты.Номер.Значение

  let data = {
    doc_guid: doc_guid,
    photos: [{ guid: currentParamGuid, dirName: dirName, fileName: fileName, fileData: src }]
  }

  // const uploadUrl = `//${vhost}/upload.php`
  // axios.put(uploadUrl, data, axiosConfig)

  axios.put(dataUrl, data, axiosConfig).then(function (response) {
    fetchCarInspectParams()
  })

  // закрываем UI
  document.getElementById('output').style.display = 'none'
  document.getElementById('modalCamera').style.display = 'none'

  // и гасим камеру
  stopCamera()
}

async function handleFileInputClick($event) {
  await saveDocument()
}

function getFileExtension(fileName) {
  return fileName.split('.').pop().toLowerCase() // Возвращает расширение в нижнем регистре
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

</script>

<template>
  <div v-if="!doc_loaded" class="loader">
    <v-progress-circular color="purple" indeterminate></v-progress-circular>
    <span class="text">Загрузка</span>
  </div>
  <div v-if="doc_loaded" id="doc-inspect">
    <v-tabs v-model="tab" bg-color="primary">
      <v-tab value="inspect">Проверка</v-tab>
      <v-tab value="info">Информация</v-tab>
      <RouterLink to="/list">
        <v-btn class="" style="position: absolute; right: 0;" color="primary" icon="mdi-home"></v-btn>
      </RouterLink>
    </v-tabs>


    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="inspect">
        <v-expansion-panels>
          <v-expansion-panel v-for="group in groups" :key="group">
            <v-expansion-panel-title>
              <h2>
                {{ group }}
                <template v-if="defectsCount(group) > 0"><v-badge color="info" v-bind:content="defectsCount(group)"
                    inline></v-badge></template>
              </h2>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <template v-for="item in res.template" :key="item.НомерСтроки">
                <template v-if="item.Группа === group">
                  <div class="input-wrapper">
                    <div class="deffect-control-wrapper">
                      <template v-if="item.Параметр.Тип === 'Справочник'">
                        <label>{{ item.Параметр.Имя }}</label>
                        <v-select clearable chips multiple return-object
                          v-model="doc.defects[item.Группа][item.Параметр.Значение_guid]"
                          v-bind:items="res.types[item.Параметр.ТипПолноеИмя].Значения" @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-select>
                      </template>
                      <template v-else-if="item.Параметр.Тип === 'Булево'">
                        <v-switch color="red" :label="item.Параметр.Имя"
                          v-model="doc.defects[item.Группа][item.Параметр.Значение_guid]" @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-switch>
                      </template>
                      <template v-else-if="item.Параметр.Тип === 'Строка'">
                        <v-textarea :label="item.Параметр.Имя"
                          v-model="doc.defects[item.Группа][item.Параметр.Значение_guid]" @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-textarea>
                      </template>
                      <template v-else-if="item.Параметр.Тип === 'Число'">
                        <v-text-field :label="item.Параметр.Имя"
                          v-model="doc.defects[item.Группа][item.Параметр.Значение_guid]" @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-text-field>
                      </template>
                      <template v-if="hasDefects(item) && needComments(item.Параметр) || mustComment(item.Параметр)">
                        <v-text-field label="Комментарий" v-model="doc.comments[item.Параметр.Значение_guid]"
                          @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-text-field>
                      </template>
                      <template v-if="hasDefects(item) && needPrice(item.Параметр)">
                        <v-text-field label="Цена" type="number" v-model="doc.prices[item.Параметр.Значение_guid]"
                          @update:modelValue="
                            ($event) => {
                              saveDocumentLocal()
                            }
                          "></v-text-field>
                      </template>
                    </div>
                    <div v-if="item.Фото" class="deffect-photos-wrapper">
                      <template v-if="
                        res.doc.ТабличныеЧасти.МедиаФайлы.filter(
                          (value) => value.Параметр.Значение_guid === item.Параметр.Значение_guid
                        ).length > 0
                      ">
                        <div class="deffect-images-wrapper">
                          <template v-for="ТекСтрока in res.doc.ТабличныеЧасти.МедиаФайлы" :key="ТекСтрока.НомерСтроки">
                            <div>
                              <a v-if="
                                ТекСтрока.Параметр.Значение_guid === item.Параметр.Значение_guid
                              " :href="pathToImage(ТекСтрока.МедиаФайл.ПутьКФайлу)" target="_blank">
                                <!-- <span>{{ pathToImage(ТекСтрока.МедиаФайл.ПутьКФайлу) }}</span> -->
                                <img class="defect-photo" :src="pathToImageThumbnail(ТекСтрока.МедиаФайл.ПутьКФайлу)" />
                              </a>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-if="
                        (typeof doc.defects[item.Группа][item.Параметр.Значение_guid] ===
                          'boolean' &&
                          doc.defects[item.Группа][item.Параметр.Значение_guid] === true) ||
                        (typeof doc.defects[item.Группа][item.Параметр.Значение_guid] ===
                          'object' &&
                          doc.defects[item.Группа][item.Параметр.Значение_guid].length > 0)
                      ">
                        <div class="image-upload-controls">
                          <v-file-input type="file" accept="image/*,video/*" label="Загрузить фото, видео:" small-chips
                            multiple v-model="doc.photos[item.Параметр.Значение_guid]" @click="handleFileInputClick"
                            @update:modelValue="
                              async ($event) => {
                                doc.photos[item.Параметр.Значение_guid].forEach((element) => {
                                  addImageToQueue(
                                    element,
                                    item.Параметр.Значение_guid,
                                    item.Параметр.Имя,
                                    getFileExtension(element.name)
                                  )
                                })
                                uploadImagesFromQueue()
                                doc.photos[item.Параметр.Значение_guid] = []
                              }
                            ">
                          </v-file-input>
                          <div v-if="uploadState[item.Параметр.Значение_guid]?.uploading" style="width: 260px">
                            <v-progress-linear :model-value="uploadState[item.Параметр.Значение_guid].progress"
                              height="6" />
                          </div>
                          <div v-if="uploadState[item.Параметр.Значение_guid]?.error"
                            style="color: red; font-size: 12px">
                            {{ uploadState[item.Параметр.Значение_guid].error }}
                          </div>
                          <div v-if="uploadState[item.Параметр.Значение_guid]?.processing"
                            style="width: 260px; color: #d97706; font-size: 12px">
                            <v-progress-linear color="warning" indeterminate height="6" class="mb-1" />
                            Данные отправлены из браузера. Сервер принимает и обрабатывает файл.
                          </div>
                          <v-btn prepend-icon="mdi-camera"
                            @click="openCamera(item.Параметр.Значение_guid, item.Параметр.Имя)">
                            Сделать фото
                          </v-btn>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </template>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="messages" v-html="messageText" />
        <div class="control-buttons">
          <!-- <v-btn prepend-icon="mdi-refresh" @click="fetchCarInspectParams"> Перечитать </v-btn> -->
          <v-btn prepend-icon="mdi-timer-play" v-if="res.doc.Реквизиты.ДатаНачала.Значение === ПустоеЗначениеДаты"
            @click="saveDocument('start')">
            Начать
          </v-btn>
          <v-btn prepend-icon="mdi-timer-check" v-if="
            res.doc.Реквизиты.ДатаНачала.Значение !== ПустоеЗначениеДаты &&
            res.doc.Реквизиты.ДатаОкончания.Значение === ПустоеЗначениеДаты
          " @click="saveDocument('stop')">
            Закончить
          </v-btn>
          <v-btn prepend-icon="mdi-content-save" :color="l_doc_guid == null ? 'green' : 'red'" @click="saveDocument">
            Сохранить
          </v-btn>
        </div>
      </v-tabs-window-item>
      <v-tabs-window-item value="info">
        <div class="info" style="margin: 10px">
          <h1>
            {{ res.doc.Реквизиты.Шаблон.Значение }} №{{
              СокращенныйНомер(res.doc.Реквизиты.Номер.Значение)
            }}
            от
            {{ new Date(res.doc.Реквизиты.Дата.Значение * 1000).toLocaleDateString() }}
          </h1>
          <p>
            <span style="font-weight: 600">Дата осмотра:</span>
            {{ new Date(res.doc.Реквизиты.ДатаОсмотра.Значение * 1000).toLocaleTimeString() }}
          </p>
          <p>
            <span style="font-weight: 600">Сотрудник:</span>

            {{ res.doc.Реквизиты.Сотрудник.Значение }}
          </p>
          <p>
            <span style="font-weight: 600">Контрагент:</span>
            {{ res.doc.Реквизиты.Контрагент.Значение }}
          </p>
          <p>
            <span style="font-weight: 600">Автомобиль:</span>
            {{ res.doc.Реквизиты.Автомобиль.Значение }}
          </p>
          <p>
            <span style="font-weight: 600">НомерДвигателя:</span>
            {{ res.doc.Реквизиты.Автомобиль.НомерДвигателя }}
          </p>
          <p>
            <span style="font-weight: 600">НомерШасси:</span>
            {{ res.doc.Реквизиты.Автомобиль.НомерШасси }}
          </p>
          <p>
            {{ new Date(res.doc.Реквизиты.ДатаНачала.Значение * 1000).toLocaleDateString() }}
          </p>
          <p>
            {{ new Date(res.doc.Реквизиты.ДатаОкончания.Значение * 1000).toLocaleDateString() }}
          </p>
        </div>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>

  <div class="modal" id="modalCamera">
    <div class="modal-content">
      <span class="close-button" @click="closeCamera()">&times;</span>
      <span id="startbutton" @click="takepicture()"></span>
      <div class="camera" id="camera">
        <video id="video">Video stream not available.</video>
      </div>
      <canvas id="canvas"> </canvas>
      <canvas id="canvas2"> </canvas>
      <div class="output" id="output">
        <span class="save-button" @click="savePhoto()"></span>
        <span class="reject-button" @click="rejectPhoto()"></span>
        <img id="photo" alt="The screen capture will appear in this box." />
        <img style="display: none" id="photo2" alt="The screen capture will appear in this box." />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.loader {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    margin-left: 10px;
    font-size: 1.2rem;
  }
}

#doc-inspect {
  .messages {
    background-color: antiquewhite;
  }

  .control-buttons {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;

    button.v-btn {
      margin: 10px;
    }
  }

  .info {
    line-height: 1.7;

    h1 {
      font-size: 1.4rem;
    }
  }

  .v-expansion-panel-text__wrapper {
    font-weight: 800;
    padding: 0;

    .image-upload-controls {
      align-items: center;
    }
  }

  img.defect-photo {
    width: auto;
    height: 50px;
  }

  .deffect-images-wrapper {
    display: flex;
    flex-wrap: wrap;

    &>div {
      padding-bottom: 10px;
    }
  }
}

#modalCamera {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: none;

  /* Полноэкранное модальное окно */
  &.modal {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
  }

  /* Содержимое модального окна */
  .modal-content {
    background: white;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0px;
    overflow-y: hidden;
    position: relative;
  }

  #canvas,
  #canvas2 {
    display: none;
  }

  .camera {
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
  }

  #video {
    width: 100%;
    height: 100%;
    background-color: aqua;
  }

  .output {
    width: 100%;
    height: 100%;
    background-color: bisque;
    position: absolute;
    justify-content: center;
    align-items: center;
    /* display: none; */
  }

  #photo {
    width: 100%;
    height: auto;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  #photo2 {
    display: none;
  }

  #startbutton {
    display: flex;
    position: absolute;
    /* Абсолютное позиционирование */
    bottom: 140px;
    /* Отступ от верхнего края */
    left: 50%;
    /* Центрирование по горизонтали */
    transform: translateX(-50%);
    /* Смещение на половину ширины элемента, чтобы точно центрировать */
    width: 50px;
    /* Ширина кружка */
    height: 50px;
    /* Высота кружка */
    background-color: red;
    /* Красный фон */
    border: 10px solid white;
    /* Белый ободок */
    border-radius: 50%;
    /* Закругление до круга */
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    /* Легкая тень для объема */
    cursor: pointer;
    /* Указатель на кнопке */
    z-index: 1001;
  }

  /* Кнопка закрытия */
  .close-button {
    position: absolute;
    bottom: 140px;
    right: 40px;
    font-size: 50px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    padding-bottom: 12px;
  }

  /* Кнопка сохранения */
  .save-button {
    position: absolute;
    bottom: 140px;
    left: 40px;
    font-size: 50px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    background: #2aff46;
    border: 1px solid #ddd;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 1001;
  }

  /* Кнопка отмены */
  .reject-button {
    position: absolute;
    bottom: 140px;
    left: 100px;
    font-size: 50px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    background: #ff8585;
    border: 1px solid #ddd;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 1001;
  }

  .close-button:hover {
    background: #f0f0f0;
  }
}
</style>
